import {useOnBoardingContext} from '../../../context/onBoarding/OnBoardingContextProvider';
import NetworkDetails from './NetworkDetails';
import OnBoardingDialog from './OnBoardingDialog';

function OnBoardingMain() {
  const {currentStep} = useOnBoardingContext();

  const renderCurrentStep = () => {
    switch (currentStep) {
      case 1:
        return <OnBoardingDialog />;
      case 2:
        return <NetworkDetails />;
      default:
        return null;
    }
  };

  return (
    <div className="w-full h-full bg-white min-h-0 overflow-hidden">
      {renderCurrentStep()}
    </div>
  );
}

export default OnBoardingMain;
